/**
 * The short code a party Crucible is shared by: typed by a friend on the
 * Crucibles tab, or carried in an invite link (`/join/<code>`). Only
 * Crucibles more than one player can join have one.
 */

/** Capital letters and digits, without the ones read as each other (0/O, 1/I/L). */
export const INVITE_CODE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
export const INVITE_CODE_LENGTH = 6;

const INVITE_CODE_PATTERN = new RegExp(`^[${INVITE_CODE_ALPHABET}]{${INVITE_CODE_LENGTH}}$`);

/** A new code, one character per `randomIndex(alphabetSize)` draw (the server passes `crypto.randomInt`). */
export function createInviteCode(randomIndex: (size: number) => number): string {
    let code = '';
    for (let index = 0; index < INVITE_CODE_LENGTH; index += 1) {
        code += INVITE_CODE_ALPHABET[randomIndex(INVITE_CODE_ALPHABET.length)];
    }
    return code;
}

/** A code as the player typed it (any case, spaces or hyphens) in its stored form, or undefined when it can't be one. */
export function normalizeInviteCode(input: string): string | undefined {
    const code = input.replace(/[\s-]/g, '').toUpperCase();
    return INVITE_CODE_PATTERN.test(code) ? code : undefined;
}
